import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spacer',
  imports: [CommonModule],
  templateUrl: './spacer.html',
  styleUrl: './spacer.scss',
})
export class Spacer {
  @Input() height: string = '2rem';
}
